import axiosInstance from './axiosInstance';

export const GetCustomerById = async (customer_id) => {
  try {
    const { data } = await axiosInstance.get(`/customer/id/${customer_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllCustomersByStore = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/customer/StoreId/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetCustListByStore = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/customer/list/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddCustomerApi = async (
  store_id,
  name,
  phone,
  email,
  website,
  contact_name,
  contact_phone,
  contact_email,
  term_id,
  opening_balance,
  b_street,
  b_city,
  b_state,
  b_zip,
  b_country,
  b_phone1,
  b_phone2,
  s_street,
  s_city,
  s_state,
  s_zip,
  s_country,
  attention_name,
  s_phone,
  note,
) => {
  try {
    const { data } = await axiosInstance.post(`/Customer`, {
      store_id: store_id,
      name: name,
      phone: phone,
      email: email,
      website: website,
      contact_name: contact_name,
      contact_phone: contact_phone,
      contact_email: contact_email,
      term_id: term_id,
      balance: opening_balance,
      billing_address: {
        street: b_street,
        city: b_city,
        state: b_state,
        zip: b_zip,
        country: b_country,
        phone1: b_phone1,
        phone2: b_phone2
      },
      shipping_address: {
        street: s_street,
        city: s_city,
        state: s_state,
        zip: s_zip,
        country: s_country,
        attention_name: attention_name,
        phone: s_phone
      },
      notes: note,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditCustomerApi = async (
  customer_id,
  store_id,
  name,
  phone,
  email,
  website,
  contact_name,
  contact_phone,
  contact_email,
  term_id,
  opening_balance,
  b_street,
  b_city,
  b_state,
  b_zip,
  b_country,
  b_phone1,
  b_phone2,
  s_street,
  s_city,
  s_state,
  s_zip,
  s_country,
  attention_name,
  s_phone,
  note,
) => {
  try {
    const { data } = await axiosInstance.put(`/customer/${customer_id}`, {
      store_id: store_id,
      name: name,
      phone: phone,
      email: email,
      website: website,
      contact_name: contact_name,
      contact_phone: contact_phone,
      contact_email: contact_email,
      term_id: term_id,
      balance: opening_balance,
      billing_address: {
        street: b_street,
        city: b_city,
        state: b_state,
        zip: b_zip,
        country: b_country,
        phone1: b_phone1,
        phone2: b_phone2
      },
      shipping_address: {
        street: s_street,
        city: s_city,
        state: s_state,
        zip: s_zip,
        country: s_country,
        attention_name: attention_name,
        phone: s_phone
      },
      notes: note,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DeleteCustomer = async (customer_id) => {
  try {
    const { data } = await axiosInstance.delete(`/customer/${customer_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
